import React, { Component, Fragment } from 'react';
import { Card, Col, Form, Row, InputNumber, Divider, Icon, Button } from 'antd';

export class ADCAForm extends Component {
    add() {
        const { form } = this.props;
        const levels = form.getFieldValue('adca_levels');
        const nextKeys = levels.concat(levels.length);
        form.setFieldsValue({ adca_levels: nextKeys });
    }

    remove(k) {
        const { form } = this.props;
        const levels = form.getFieldValue('adca_levels');
        if (levels.length === 1) {
            return;
        }

        form.setFieldsValue({ adca_levels: levels.filter(key => key !== k) });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('adca_levels', { initialValue: [] });
        const levels = getFieldValue('adca_levels');
        return (
            <Card title="Auto DCA" bordered={false} style={{ marginBottom: 15 }}>
                <Row gutter={24}>
                    <Col md={12}>
                        <Form.Item label="Cooldown">
                            {getFieldDecorator(`adca_cooldown`, {
                                initialValue: 0,
                                rules: [
                                    {
                                        required: true,
                                        message: 'Please input cooldown'
                                    }
                                ]
                            })(<InputNumber min={0} style={{ width: '100%' }} />)}
                        </Form.Item>
                    </Col>

                    {levels.map((k, index) => {
                        return (
                            <Fragment key={index}>
                                <Divider>
                                    Level {index + 1}{' '}
                                    {index > 0 ? (
                                        <Icon
                                            className="dynamic-delete-button"
                                            type="minus-circle-o"
                                            style={{ color: '#ba7272' }}
                                            disabled={levels.length === 1}
                                            onClick={() => this.remove(k)}
                                        />
                                    ) : null}
                                </Divider>
                                <Row gutter={24}>
                                    <Col xs={12}>
                                        <Form.Item label="Threshold">
                                            {getFieldDecorator(`adca_threshold[${index}]`, {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please input threshold'
                                                    }
                                                ]
                                            })(<InputNumber min={0} style={{ width: '100%' }} />)}
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Item label="Multiplier">
                                            {getFieldDecorator(`adca_multiplier[${index}]`, {
                                                initialValue: 1,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Please input threshold'
                                                    }
                                                ]
                                            })(<InputNumber min={0} style={{ width: '100%' }} />)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Fragment>
                        );
                    })}

                    <Button type="dashed" block onClick={this.add.bind(this)}>
                        <Icon type="plus" /> Add Level
                    </Button>
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/ADCAForm.js